"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNucleusSplitProject = isNucleusSplitProject;
exports.resolveSplitScheduleInvoiceNumber = resolveSplitScheduleInvoiceNumber;
/** True when project metadata describes a Nucleus split (multi-tranche) billing schedule. */
function isNucleusSplitProject(metadata) {
    if (!metadata) {
        return false;
    }
    const mode = String(metadata["collectionMode"] ?? "").trim();
    if (mode !== "split") {
        return false;
    }
    const schedule = metadata["paymentSchedule"];
    return Array.isArray(schedule) && schedule.length >= 2;
}
/** Display / accounting invoice number for a split schedule (falls back to first tranche code). */
function resolveSplitScheduleInvoiceNumber(projectMetadata, fallbackTrancheInvoiceCode) {
    const raw = projectMetadata?.["invoiceNumber"];
    if (typeof raw === "string" && raw.trim()) {
        return raw.trim();
    }
    return fallbackTrancheInvoiceCode.trim();
}
